import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.5406 9.07768C10.8471 9.07768 12.7169 7.23355 12.7169 4.9587C12.7169 2.68385 10.8471 0.839722 8.5406 0.839722C6.23407 0.839722 4.36426 2.68385 4.36426 4.9587C4.36426 7.23355 6.23407 9.07768 8.5406 9.07768Z"
      stroke="black"
      strokeWidth="0.765862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.2832 18.7071C1.29681 16.832 1.8679 14.9521 3.0203 13.4169C5.61416 9.96156 10.17 9.56131 13.1962 12.5229C14.8433 14.1349 15.6978 16.4105 15.7164 18.7071"
      stroke="black"
      strokeWidth="0.765862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.28418 18.7205H15.7135"
      stroke="black"
      strokeWidth="0.765862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { SvgComponent as UserIcon };
